const teams = {
  en: {
    eyebrow: 'Organisation',
    title: 'Teams',
    subtitle: 'Build your call-center, sales and control teams and assign staff.',
    newTeam: 'New team',
    statTeams: 'Teams',
    statMembers: 'Members',
    statCallCenter: 'Call center',
    statSales: 'Sales',
    drawerEnrolled: '{count} enrolled',
    drawerInvitedSuffix: '{count} invited',
    loading: 'Loading teams…',
    emptyTitle: 'No teams yet',
    emptyDesc: 'Create your first team — a call center to follow up on students, a sales team, or a control team.',
    emptyAction: '+ New team',
    edit: 'Edit',
    delete: 'Delete',
    inactive: 'Inactive',
    noMembersYet: 'No members yet',
    memberCount: '{count} members',
    memberCountOne: '1 member',
    leadPrefix: 'Lead:',
    manageMembers: 'Manage members →',
    editTeamTitle: 'Edit team',
    newTeamTitle: 'New team',
    teamNameLabel: 'Team name *',
    teamNamePlaceholder: 'e.g. Call Center — UZ',
    teamTypeLabel: 'Team type',
    descriptionLabel: 'Description',
    optional: '(optional)',
    descriptionPlaceholder: 'What this team is responsible for',
    activeTeam: 'Active team',
    cancel: 'Cancel',
    saving: 'Saving…',
    saveChanges: 'Save changes',
    createTeam: 'Create team',
    selectStudentPlaceholder: 'Select an existing student…',
    addExistingStudentAria: 'Add existing student',
    add: 'Add',
    orAddByContact: 'or add by email / phone',
    addByContactAria: 'Add by email or phone',
    contactPlaceholder: 'student@email.com or +99890…',
    adding: 'Adding…',
    createStaffLoginToggle: 'Create a staff login (they can sign in)',
    signsInAs: 'Signs in as {role}',
    canAccess: 'Can access',
    cannotAccess: 'Cannot access',
    fullNameLabel: 'Full name *',
    fullNamePlaceholder: 'e.g. Dilnoza Karimova',
    contactLabel: 'Email or phone *',
    contactPlaceholder2: 'agent@darsly.uz or +99890…',
    tempPasswordLabel: 'Temporary password *',
    generate: 'Generate',
    copy: 'Copy',
    copied: 'Copied',
    shareHint: 'Share this with the member — they can change it after signing in.',
    creating: 'Creating…',
    createLogin: 'Create login',
    noMembersYetLong: 'No members yet. Add someone above.',
    lead: 'Lead',
    invited: 'Invited',
    pendingSignup: 'Pending sign-up',
    removeLead: 'Remove lead',
    makeLead: 'Make lead',
    remove: 'Remove',
    staffLoginCreatedTitle: 'Staff login created',
    shareCreds: 'Share these with {name} — the password won’t be shown again.',
    loginLabel: 'Login',
    passwordLabel: 'Password',
    copyLoginPassword: 'Copy login & password',
    done: 'Done',
    deleteTeamTitle: 'Delete team?',
    deleteTeamMsg: 'Delete {name}? Members will be unassigned, and the staff logins of members who are in no other team are turned off. This can’t be undone.',
    deleteAction: 'Delete',
    typeCallCenter: 'Call Center',
    typeCallCenterBlurb: 'Tracks student progress & retention',
    typeSales: 'Sales',
    typeSalesBlurb: 'Owns leads, orders & conversion',
    typeControl: 'Control',
    typeControlBlurb: 'Oversight & QA across teams',
    typeGeneral: 'General',
    typeGeneralBlurb: 'Any other internal team',
    toastLoadFailed: 'Failed to load teams',
    toastTeamNameRequired: 'Team name is required.',
    toastTeamUpdated: 'Team updated',
    toastTeamCreated: 'Team created',
    toastSaveTeamFailed: 'Failed to save team.',
    toastTeamDeleted: 'Team deleted',
    toastDeleteFailed: 'Failed to delete',
    toastAddMemberFailed: 'Could not add member',
    toastInvited: 'Invited — they’ll be enrolled when they sign up',
    toastMemberAdded: 'Student added to the group',
    toastEnterName: 'Enter a name',
    toastEnterContact: 'Enter an email or phone',
    toastPasswordMinLength: 'Password must be at least 6 characters',
    toastStaffLoginCreated: 'Staff login created',
    toastCreateStaffFailed: 'Could not create staff login',
    toastRemoveMemberFailed: 'Could not remove member',
    toastMemberLoginOff: 'Removed. {name} is in no team now, so their staff login is turned off. Adding them to a team turns it back on.',
    toastTeamDeletedLoginsOff: 'Team deleted. Staff logins turned off (in no other team): {count}.',
    toastUpdateMemberFailed: 'Could not update member',
    toastLinkedExisting: 'Linked the existing {role} account. Its password and role were not changed, so no new login was created.',
    roleName: {
      ADMIN: 'Admin',
      SALES: 'Sales',
      CALL_CENTER: 'Call Center',
      CONTROL: 'Control',
      ACCOUNT_MANAGER: 'Account Manager',
      MENTOR: 'Mentor',
      STAFF: 'Staff',
    },
    access: {
      fullAccess: 'Full access to every area',
      revenueAndAnalytics: 'Revenue, orders & all analytics',
      manageStaffTeamsSettings: 'Manage staff, teams & settings',
      revenueOrdersAmounts: 'Revenue, orders & amounts',
      promocodesDiscounts: 'Promocodes & discounts',
      salesAnalytics: 'Sales analytics',
      studentsCourses: 'Students & courses',
      manageStaffTeams: 'Manage staff / teams',
      systemSettings: 'System settings',
      studentProgressAtRisk: 'Student progress & at-risk tracking',
      messagingFollowUps: 'Messaging / follow-ups',
      calendar: 'Calendar',
      salesPromocodes: 'Sales & promocodes',
      oversight: 'Oversight of students, courses & activity',
      nonFinancialAnalytics: 'Non-financial analytics',
      messaging: 'Messaging',
      revenueAmounts: 'Revenue & amounts',
      clientOrgs: 'Client organizations, seats & cohorts',
      students: 'Students',
      sales: 'Sales',
      ownCourses: 'Your own courses & lessons',
      studentsProgress: 'Students & their progress',
    },
    people: {
      roleModerator: 'Moderator',
      roleMentor: 'Mentor',
      moderators: 'Moderators',
      mentors: 'Mentors',
      inactiveNotApplied: 'Member added, but could not be set to Inactive. Edit the member to try again.',
    },
    studentsHub: {
      eyebrow: 'People',
      subtitle: 'Track enrollment progress and spot students who need attention.',
    },
  },
  ru: {
    eyebrow: 'Организация',
    title: 'Команды',
    subtitle: 'Создавайте колл-центр, отдел продаж и контрольную команду, назначайте сотрудников.',
    newTeam: 'Новая команда',
    statTeams: 'Команды',
    statMembers: 'Участники',
    statCallCenter: 'Колл-центр',
    statSales: 'Продажи',
    drawerEnrolled: '{count} зачислено',
    drawerInvitedSuffix: '{count} приглашено',
    loading: 'Загрузка команд…',
    emptyTitle: 'Пока нет команд',
    emptyDesc: 'Создайте первую команду — колл-центр для работы со студентами, отдел продаж или контрольную команду.',
    emptyAction: '+ Новая команда',
    edit: 'Изменить',
    delete: 'Удалить',
    inactive: 'Неактивна',
    noMembersYet: 'Пока нет участников',
    memberCount: '{count} участников',
    memberCountOne: '1 участник',
    leadPrefix: 'Руководитель:',
    manageMembers: 'Управлять участниками →',
    editTeamTitle: 'Изменить команду',
    newTeamTitle: 'Новая команда',
    teamNameLabel: 'Название команды *',
    teamNamePlaceholder: 'напр. Колл-центр — UZ',
    teamTypeLabel: 'Тип команды',
    descriptionLabel: 'Описание',
    optional: '(необязательно)',
    descriptionPlaceholder: 'За что отвечает эта команда',
    activeTeam: 'Активная команда',
    cancel: 'Отмена',
    saving: 'Сохранение…',
    saveChanges: 'Сохранить изменения',
    createTeam: 'Создать команду',
    selectStudentPlaceholder: 'Выберите существующего студента…',
    addExistingStudentAria: 'Добавить существующего студента',
    add: 'Добавить',
    orAddByContact: 'или добавьте по email / телефону',
    addByContactAria: 'Добавить по email или телефону',
    contactPlaceholder: 'student@email.com или +99890…',
    adding: 'Добавление…',
    createStaffLoginToggle: 'Создать логин сотрудника (сможет войти)',
    signsInAs: 'Входит как {role}',
    canAccess: 'Доступно',
    cannotAccess: 'Недоступно',
    fullNameLabel: 'Полное имя *',
    fullNamePlaceholder: 'напр. Dilnoza Karimova',
    contactLabel: 'Email или телефон *',
    contactPlaceholder2: 'agent@darsly.uz или +99890…',
    tempPasswordLabel: 'Временный пароль *',
    generate: 'Сгенерировать',
    copy: 'Копировать',
    copied: 'Скопировано',
    shareHint: 'Передайте это участнику — он сможет изменить пароль после входа.',
    creating: 'Создание…',
    createLogin: 'Создать логин',
    noMembersYetLong: 'Пока нет участников. Добавьте кого-нибудь выше.',
    lead: 'Руководитель',
    invited: 'Приглашён',
    pendingSignup: 'Ожидает регистрации',
    removeLead: 'Снять руководителя',
    makeLead: 'Назначить руководителем',
    remove: 'Удалить',
    staffLoginCreatedTitle: 'Логин сотрудника создан',
    shareCreds: 'Передайте это участнику «{name}» — пароль больше не будет показан.',
    loginLabel: 'Логин',
    passwordLabel: 'Пароль',
    copyLoginPassword: 'Копировать логин и пароль',
    done: 'Готово',
    deleteTeamTitle: 'Удалить команду?',
    deleteTeamMsg: 'Удалить «{name}»? Участники будут откреплены, а вход сотрудников, которые не состоят в других командах, будет отключён. Это действие необратимо.',
    deleteAction: 'Удалить',
    typeCallCenter: 'Колл-центр',
    typeCallCenterBlurb: 'Отслеживает прогресс и удержание студентов',
    typeSales: 'Продажи',
    typeSalesBlurb: 'Отвечает за лиды, заказы и конверсию',
    typeControl: 'Контроль',
    typeControlBlurb: 'Надзор и контроль качества всех команд',
    typeGeneral: 'Общая',
    typeGeneralBlurb: 'Любая другая внутренняя команда',
    toastLoadFailed: 'Не удалось загрузить команды',
    toastTeamNameRequired: 'Введите название команды.',
    toastTeamUpdated: 'Команда обновлена',
    toastTeamCreated: 'Команда создана',
    toastSaveTeamFailed: 'Не удалось сохранить команду.',
    toastTeamDeleted: 'Команда удалена',
    toastDeleteFailed: 'Не удалось удалить',
    toastAddMemberFailed: 'Не удалось добавить участника',
    toastInvited: 'Приглашён — будет зачислен после регистрации',
    toastMemberAdded: 'Студент добавлен в группу',
    toastEnterName: 'Введите имя',
    toastEnterContact: 'Введите email или телефон',
    toastPasswordMinLength: 'Пароль должен содержать не менее 6 символов',
    toastStaffLoginCreated: 'Логин сотрудника создан',
    toastCreateStaffFailed: 'Не удалось создать логин сотрудника',
    toastRemoveMemberFailed: 'Не удалось удалить участника',
    toastMemberLoginOff: 'Удалён. {name} больше не состоит ни в одной команде, поэтому вход сотрудника отключён. Добавьте его в команду, чтобы включить снова.',
    toastTeamDeletedLoginsOff: 'Команда удалена. Отключено входов сотрудников (не состоят в других командах): {count}.',
    toastUpdateMemberFailed: 'Не удалось обновить участника',
    toastLinkedExisting: 'Привязан существующий аккаунт ({role}). Его пароль и роль не изменены, новый логин не создан.',
    roleName: {
      ADMIN: 'Администратор',
      SALES: 'Продажи',
      CALL_CENTER: 'Колл-центр',
      CONTROL: 'Контроль',
      ACCOUNT_MANAGER: 'Менеджер по клиентам',
      MENTOR: 'Ментор',
      STAFF: 'Сотрудник',
    },
    access: {
      fullAccess: 'Полный доступ ко всем разделам',
      revenueAndAnalytics: 'Выручка, заказы и вся аналитика',
      manageStaffTeamsSettings: 'Управление сотрудниками, командами и настройками',
      revenueOrdersAmounts: 'Выручка, заказы и суммы',
      promocodesDiscounts: 'Промокоды и скидки',
      salesAnalytics: 'Аналитика продаж',
      studentsCourses: 'Студенты и курсы',
      manageStaffTeams: 'Управление сотрудниками и командами',
      systemSettings: 'Системные настройки',
      studentProgressAtRisk: 'Прогресс студентов и отслеживание группы риска',
      messagingFollowUps: 'Сообщения и повторные контакты',
      calendar: 'Календарь',
      salesPromocodes: 'Продажи и промокоды',
      oversight: 'Контроль студентов, курсов и активности',
      nonFinancialAnalytics: 'Аналитика без финансовых данных',
      messaging: 'Сообщения',
      revenueAmounts: 'Выручка и суммы',
      clientOrgs: 'Организации-клиенты, места и когорты',
      students: 'Студенты',
      sales: 'Продажи',
      ownCourses: 'Свои курсы и уроки',
      studentsProgress: 'Студенты и их прогресс',
    },
    people: {
      roleModerator: 'Модератор',
      roleMentor: 'Ментор',
      moderators: 'Модераторы',
      mentors: 'Менторы',
      inactiveNotApplied: 'Участник добавлен, но сделать его неактивным не удалось. Измените участника и повторите.',
    },
    studentsHub: {
      eyebrow: 'Люди',
      subtitle: 'Отслеживайте прогресс обучения и находите учеников, которым нужна помощь.',
    },
  },
  uz: {
    eyebrow: 'Tashkilot',
    title: 'Jamoalar',
    subtitle: "Call-markaz, sotuv va nazorat jamoalarini tuzing va xodimlarni tayinlang.",
    newTeam: 'Yangi jamoa',
    statTeams: 'Jamoalar',
    statMembers: "A'zolar",
    statCallCenter: 'Call-markaz',
    statSales: 'Sotuv',
    drawerEnrolled: "{count} ro'yxatga olingan",
    drawerInvitedSuffix: '{count} taklif qilindi',
    loading: 'Jamoalar yuklanmoqda…',
    emptyTitle: "Hali jamoalar yo'q",
    emptyDesc: "Birinchi jamoangizni yarating — talabalar bilan ishlash uchun call-markaz, sotuv jamoasi yoki nazorat jamoasi.",
    emptyAction: '+ Yangi jamoa',
    edit: 'Tahrirlash',
    delete: "O'chirish",
    inactive: 'Nofaol',
    noMembersYet: "Hali a'zolar yo'q",
    memberCount: "{count} a'zo",
    memberCountOne: "1 a'zo",
    leadPrefix: 'Yetakchi:',
    manageMembers: "A'zolarni boshqarish →",
    editTeamTitle: 'Jamoani tahrirlash',
    newTeamTitle: 'Yangi jamoa',
    teamNameLabel: 'Jamoa nomi *',
    teamNamePlaceholder: 'masalan, Call-markaz — UZ',
    teamTypeLabel: 'Jamoa turi',
    descriptionLabel: 'Tavsif',
    optional: '(ixtiyoriy)',
    descriptionPlaceholder: 'Bu jamoa nima uchun javobgar',
    activeTeam: 'Faol jamoa',
    cancel: 'Bekor qilish',
    saving: 'Saqlanmoqda…',
    saveChanges: "O'zgarishlarni saqlash",
    createTeam: 'Jamoa yaratish',
    selectStudentPlaceholder: 'Mavjud talabani tanlang…',
    addExistingStudentAria: "Mavjud talabani qo'shish",
    add: "Qo'shish",
    orAddByContact: "yoki email / telefon orqali qo'shing",
    addByContactAria: "Email yoki telefon orqali qo'shish",
    contactPlaceholder: 'student@email.com yoki +99890…',
    adding: "Qo'shilmoqda…",
    createStaffLoginToggle: 'Xodim uchun login yaratish (tizimga kira oladi)',
    signsInAs: '{role} sifatida kiradi',
    canAccess: 'Ruxsat berilgan',
    cannotAccess: 'Ruxsat berilmagan',
    fullNameLabel: "To'liq ism *",
    fullNamePlaceholder: 'masalan, Dilnoza Karimova',
    contactLabel: 'Email yoki telefon *',
    contactPlaceholder2: 'agent@darsly.uz yoki +99890…',
    tempPasswordLabel: 'Vaqtinchalik parol *',
    generate: 'Generatsiya qilish',
    copy: 'Nusxalash',
    copied: 'Nusxalandi',
    shareHint: "Buni a'zoga bering — tizimga kirgandan so'ng parolni o'zgartira oladi.",
    creating: 'Yaratilmoqda…',
    createLogin: 'Login yaratish',
    noMembersYetLong: "Hali a'zolar yo'q. Yuqorida birontasini qo'shing.",
    lead: 'Yetakchi',
    invited: 'Taklif qilindi',
    pendingSignup: "Ro'yxatdan o'tishi kutilmoqda",
    removeLead: 'Yetakchilikni olib tashlash',
    makeLead: 'Yetakchi qilish',
    remove: "O'chirish",
    staffLoginCreatedTitle: 'Xodim login yaratildi',
    shareCreds: 'Buni "{name}" bilan bo\'lishing — parol qayta ko\'rsatilmaydi.',
    loginLabel: 'Login',
    passwordLabel: 'Parol',
    copyLoginPassword: 'Login va parolni nusxalash',
    done: 'Tayyor',
    deleteTeamTitle: "Jamoani o'chirishmi?",
    deleteTeamMsg: '"{name}" o\'chirilsinmi? A\'zolar biriktirilmagan holga o\'tadi, boshqa jamoada bo\'lmagan xodimlarning kirishi o\'chiriladi. Buni bekor qilib bo\'lmaydi.',
    deleteAction: "O'chirish",
    typeCallCenter: 'Call-markaz',
    typeCallCenterBlurb: "Talabalar progressi va ushlab qolinishini kuzatadi",
    typeSales: 'Sotuv',
    typeSalesBlurb: "Lidlar, buyurtmalar va konversiyaga javobgar",
    typeControl: 'Nazorat',
    typeControlBlurb: "Barcha jamoalar bo'yicha nazorat va sifat tekshiruvi",
    typeGeneral: 'Umumiy',
    typeGeneralBlurb: 'Boshqa har qanday ichki jamoa',
    toastLoadFailed: "Jamoalarni yuklab bo'lmadi",
    toastTeamNameRequired: 'Jamoa nomini kiriting.',
    toastTeamUpdated: 'Jamoa yangilandi',
    toastTeamCreated: 'Jamoa yaratildi',
    toastSaveTeamFailed: "Jamoani saqlab bo'lmadi.",
    toastTeamDeleted: "Jamoa o'chirildi",
    toastDeleteFailed: "O'chirib bo'lmadi",
    toastAddMemberFailed: "A'zoni qo'shib bo'lmadi",
    toastInvited: "Taklif qilindi — ro'yxatdan o'tgach qo'shiladi",
    toastMemberAdded: "Talaba guruhga qo'shildi",
    toastEnterName: 'Ismni kiriting',
    toastEnterContact: 'Email yoki telefon kiriting',
    toastPasswordMinLength: "Parol kamida 6 ta belgidan iborat bo'lishi kerak",
    toastStaffLoginCreated: 'Xodim login yaratildi',
    toastCreateStaffFailed: "Xodim login yaratib bo'lmadi",
    toastRemoveMemberFailed: "A'zoni o'chirib bo'lmadi",
    toastMemberLoginOff: "O'chirildi. {name} endi hech qaysi jamoada emas, shuning uchun xodim sifatida kirishi o'chirildi. Jamoaga qayta qo'shsangiz, yana yoqiladi.",
    toastTeamDeletedLoginsOff: "Jamoa o'chirildi. Boshqa jamoada bo'lmagan xodimlarning kirishi o'chirildi: {count}.",
    toastUpdateMemberFailed: "A'zoni yangilab bo'lmadi",
    toastLinkedExisting: "Mavjud {role} hisobi bog'landi. Uning paroli va roli o'zgarmadi, yangi login yaratilmadi.",
    roleName: {
      ADMIN: 'Admin',
      SALES: 'Sotuv',
      CALL_CENTER: 'Call-markaz',
      CONTROL: 'Nazorat',
      ACCOUNT_MANAGER: 'Mijozlar menejeri',
      MENTOR: 'Mentor',
      STAFF: 'Xodim',
    },
    access: {
      fullAccess: "Barcha bo'limlarga to'liq kirish",
      revenueAndAnalytics: 'Daromad, buyurtmalar va barcha tahlillar',
      manageStaffTeamsSettings: 'Xodimlar, jamoalar va sozlamalarni boshqarish',
      revenueOrdersAmounts: 'Daromad, buyurtmalar va summalar',
      promocodesDiscounts: 'Promokodlar va chegirmalar',
      salesAnalytics: 'Sotuv tahlili',
      studentsCourses: 'Talabalar va kurslar',
      manageStaffTeams: 'Xodimlar va jamoalarni boshqarish',
      systemSettings: 'Tizim sozlamalari',
      studentProgressAtRisk: 'Talabalar progressi va xavf guruhini kuzatish',
      messagingFollowUps: "Xabarlar va qayta aloqa",
      calendar: 'Kalendar',
      salesPromocodes: 'Sotuvlar va promokodlar',
      oversight: 'Talabalar, kurslar va faollik ustidan nazorat',
      nonFinancialAnalytics: "Moliyaviy bo'lmagan tahlil",
      messaging: 'Xabarlar',
      revenueAmounts: 'Daromad va summalar',
      clientOrgs: "Mijoz tashkilotlari, o'rinlar va kohortalar",
      students: 'Talabalar',
      sales: 'Sotuvlar',
      ownCourses: "O'zingizning kurs va darslaringiz",
      studentsProgress: 'Talabalar va ularning progressi',
    },
    people: {
      roleModerator: 'Moderator',
      roleMentor: 'Mentor',
      moderators: 'Moderatorlar',
      mentors: 'Mentorlar',
      inactiveNotApplied: "A'zo qo'shildi, lekin uni nofaol qilib bo'lmadi. A'zoni tahrirlab, qayta urinib ko'ring.",
    },
    studentsHub: {
      eyebrow: 'Odamlar',
      subtitle: "O'quvchilarning progressini kuzating va e'tibor talab qiladiganlarni toping.",
    },
  },
};

export default teams;
